module.exports = __webpack_public_path__ + "static/Icons_LTV_Active-0e57466ede766d758681df30c73225c4.png";